module.exports = __webpack_public_path__ + "static/media/spatiam_logo_white.0ca1e546.png";